import React from 'react';
import PropTypes from 'prop-types';
import AIcon from '../atoms/_atoms.icon';

export default class MFaq extends React.Component {
	constructor(props) {
		super(props);

		this.state = { isOpen: props.isOpen };
		this.bindHandles();
	}

	componentWillReceiveProps(props) {
		if (props.isOpen !== this.state.isOpen) {
			this.setState({ isOpen: props.isOpen });
		}
	}

	bindHandles() {
		this.handleClick = this.handleClick.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
	}

	handleClick() {
		if (this.props.onClick) {
			this.props.onClick(!this.state.isOpen);
		}
		this.setState(prevState => ({ isOpen: !prevState.isOpen }));
	}

	handleKeyDown(event) {
		if (event.keyCode !== 13) {
			return;
		}
		this.handleClick();
	}

	render() {
		const classNameBody = this.state.isOpen ? 'm-faq--body active' : 'm-faq--body';

		return (
			<section className="m-faq">
				<header
					className="m-faq--header"
					onClick={this.handleClick}
					onKeyDown={this.handleKeyDown}
					tabIndex="0"
					role="button"
				>
					<p className="bold">{this.props.question}</p>
					<AIcon type="arrowDown" />
				</header>
				<article className={classNameBody}>
					<p>{this.props.answer}</p>
				</article>
			</section>
		);
	}
}

MFaq.propTypes = {
	question: PropTypes.string.isRequired,
	answer: PropTypes.string.isRequired,
	isOpen: PropTypes.bool,
	onClick: PropTypes.func,
};

MFaq.defaultProps = {
	isOpen: false,
	onClick: undefined,
}



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.faq.js